import Vue from 'vue';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ru-RU';
import './element-variables.scss';

Vue.use(ElementUI, {
  locale,
});
